// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3E1tM","content":"styles_content__2hYhp","row":"styles_row__3_P8j","footer":"styles_footer__2sf_R","phraseLength":"styles_phraseLength__Q2jBL"};